export default [
  ["", null],
  ["Nombre", "name"],
  ["Dirección", "address"],
  ["Zona", null],
  ["", null]
];
